import { render, staticRenderFns } from "./AdminRoleAccess.vue?vue&type=template&id=1ebf1231&scoped=true&"
import script from "./AdminRoleAccess.vue?vue&type=script&lang=js&"
export * from "./AdminRoleAccess.vue?vue&type=script&lang=js&"
import style0 from "./AdminRoleAccess.vue?vue&type=style&index=0&id=1ebf1231&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebf1231",
  null
  
)

export default component.exports